import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { TEXT_COLORS, BG_COLORS, BORDER_COLORS } from '../../utils/colors';

interface GlassButtonProps extends ButtonProps {
  glassVariant?: 'primary' | 'secondary' | 'outlined';
  href?: string;
  target?: string;
  rel?: string;
  download?: boolean | string;
}

const GlassButton: React.FC<GlassButtonProps> = ({
  glassVariant = 'primary',
  sx,
  children,
  ...props
}) => {
  const getStyles = () => {
    switch (glassVariant) {
      case 'primary':
        return {
          borderRadius: '8px',
          padding: '6px 24px',
          background: 'rgba(185, 28, 28, 0.15)',
          border: '1px solid rgba(185, 28, 28, 0.5)',
          color: '#fff',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s ease',
          '&:hover': {
            background: 'rgba(185, 28, 28, 0.3)',
            borderColor: '#dc2626',
            boxShadow: '0 0 20px rgba(185, 28, 28, 0.4)',
          },
          '&:disabled': {
            background: 'rgba(100, 100, 100, 0.15)',
            borderColor: 'rgba(100, 100, 100, 0.3)',
            color: TEXT_COLORS.DISABLED,
          },
        };
      case 'secondary':
        return {
          borderRadius: '8px',
          padding: '6px 24px',
          background: BG_COLORS.GLASS_DARK,
          border: `1px solid ${BORDER_COLORS.STRONG}`,
          color: '#fff',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s ease',
          '&:hover': {
            background: BG_COLORS.GLASS_LIGHT,
            borderColor: BORDER_COLORS.FOCUS,
            boxShadow: `0 0 15px ${BG_COLORS.GLASS_LIGHT}`,
          },
          '&:disabled': {
            background: 'rgba(100, 100, 100, 0.1)',
            borderColor: 'rgba(100, 100, 100, 0.2)',
            color: TEXT_COLORS.DISABLED,
          },
        };
      case 'outlined':
        return {
          borderRadius: '8px',
          padding: '6px 24px',
          background: 'transparent',
          border: '1px solid rgba(185, 28, 28, 0.5)',
          color: '#dc2626',
          transition: 'all 0.3s ease',
          '&:hover': {
            background: 'rgba(185, 28, 28, 0.1)',
            borderColor: '#dc2626',
            boxShadow: '0 0 15px rgba(185, 28, 28, 0.3)',
          },
          '&:disabled': {
            borderColor: 'rgba(100, 100, 100, 0.3)',
            color: TEXT_COLORS.DISABLED,
          },
        };
      default:
        return {};
    }
  };

  return (
    <Button
      {...props}
      sx={{
        ...getStyles(),
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default GlassButton;
